export class ImpactReport {
  constructor(
    recycledByBoomerangCount,
    recycledByRepairerCount,
    repaired,
    other
  ) {
    this.recycledByBoomerangCount = recycledByBoomerangCount
    this.recycledByRepairerCount = recycledByRepairerCount
    this.repaired = repaired
    this.other = other
  }
}
